<template>
    <div>
        <div class="loading" v-if="loading">
            <div class="loadingBox text-center">
                <div>
                    <img :src="loadingImg">
                </div>
                <div class="mt-2">
                    Cargando
                </div>
            </div>
        </div>
        <AppSidebar v-if="!disableSidebar"/>
        <div class="sidebar-backdrop"
             v-if="sidebarStatus && !disableSidebar"
             @click="$store.commit({type: 'updateSidebarVisible', value: false})"></div>
        <div :class="'wrapper d-flex flex-column min-vh-100 ' + (sidebarStatus && !disableSidebar ? 'sidebarShow' : 'sidebarHide')">
            <div v-if="authInfo && authInfo.emu" class="emulacionBarra">
                <i class="ti ti-user-share"></i>
                <span>{{ $t('emulacion.banner', {nombre: authInfo.name}) }}</span>
                <button class="btn btn-sm btn-light ms-auto" @click="volverDeEmulacion">{{ $t('emulacion.volver') }}</button>
            </div>
            <AppHeader/>
            <div class="body flex-grow-1">
                <router-view/>
            </div>
            <AppFooter v-if="!disableSidebar"/>
        </div>
    </div>
</template>
<script>
import {CContainer} from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import {mapGetters, useStore} from "vuex";
import toolbox from "@/toolbox";
import {volverAlAdmin} from "@/utils/emulacion";

import loadingImg from '@/assets/images/loading.gif'

export default {
    name: 'DefaultLayout',
    components: {
        AppFooter,
        AppHeader,
        AppSidebar,
        CContainer,
    },
    computed: {
        ...mapGetters({
            loading: 'loading',
            authInfo: 'authInfo',
            disableSidebar: 'disableSidebar',
            sidebarStatus: 'sidebarStatus',
        })
    },
    setup() {
        const store = useStore()
        return {
            loadingImg,
        }
    },
    mounted() {
        //console.log(this.authInfo);
    },
    methods: {
        volverDeEmulacion() {
            // Se vuelve aunque falle el aviso al servidor: la emulación igual vence sola
            toolbox.doAjax('POST', 'users/emulacion/terminar', {}, volverAlAdmin, volverAlAdmin);
        },
    }
}
</script>

<style scoped>
/* Visible en todas las pantallas mientras se emula: quien opera debe saber como quién lo hace */
.emulacionBarra {
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1040;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: calc(100% - 32px);
    padding: 8px 8px 8px 16px;
    border-radius: 24px;
    background: #2c2e32;
    color: #fff;
    font-size: 0.875rem;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}
.emulacionBarra .btn {
    border-radius: 16px;
    white-space: nowrap;
}
</style>
